export const theme = {
  background: '#4D535E',
  primary: '#D396ED',
  secondary: '#CEF5D3',
}
